<template>
  <vehiclesList/>
</template>
<script>
import vehiclesList from '@/components/modules/schoolroutes/vehicles/list'
export default {
  name: 'vehicles',
  components: {
    vehiclesList
  }
}
</script>



// WEBPACK FOOTER //
// src/views/schoolroutes/vehicles/list.vue